import {localesMyAppSupports} from '../../utils/i18n';
import type {RootState} from '../store';

type SupportedLanguage = (typeof localesMyAppSupports)[number];

const params = new URLSearchParams(window.location.search);
const langParam = params.get('lang');

function isSupportedLanguage(lang: unknown): lang is SupportedLanguage {
  return localesMyAppSupports.includes(lang as SupportedLanguage);
}

export const getAdminLanguage = (state: RootState) => {
  const adminLanguage = state.auth.get('language');

  return (
    (isSupportedLanguage(langParam) && langParam) ||
    (isSupportedLanguage(adminLanguage) && adminLanguage) ||
    'en'
  );
};
